import { ShortTextV1FieldFactory } from './fields/short-text-v1-field-factory';
import { EmailTextV1FieldFactory } from './fields/email-text-v1-field-factory';
import { NumberTextV1FieldFactory } from './fields/number-text-v1-field-factory';
import { UrlTextV1FieldFactory } from './fields/url-text-v1-field-factory';
import { RichTextV1FieldFactory } from './fields/rich-text-v1-field-factory';
import { MultipleChoiceV1FieldFactory } from './fields/multiple-choice-v1-field-factory';
import { DropdownSelectorV1FieldFactory } from './fields/dropdown-selector-v1-field-factory';
import { DateV1FieldFactory } from './fields/date-v1-field-factory';
import { FilesV1FieldFactory } from './fields/files-v1-field-factory';
import { UserSelectorV1FieldFactory } from './fields/user-selector-v1-field-factory';
import { MultipleTagSelectorV1FieldFactory } from './fields/multiple-tag-selector-v1-field-factory';
import { SingleTagSelectorV1FieldFactory } from './fields/single-tag-selector-v1-field-factory';
import { ArtworkLinkSelectorV1FieldFactory } from './fields/artwork-link-selector-v1-field-factory';
import { DynamicUrlLinkButtonV1FieldFactory } from './fields/dynamic-url-link-button-v1-field-factory';
// import { CodeGeneratorV1FieldFactory } from './fields/code-generator-v1-field-factory';

/**
 * this list defines the order in how menu in settins is displayed
 * 
 * @todo CodeGeneratorV1FieldFactory will be implemented after first release
 *
 */
export const fieldFactoriesList = [
    ShortTextV1FieldFactory,
    EmailTextV1FieldFactory,
    NumberTextV1FieldFactory,
    UrlTextV1FieldFactory,
    RichTextV1FieldFactory,
    MultipleChoiceV1FieldFactory,
    DropdownSelectorV1FieldFactory,
    DateV1FieldFactory,
    FilesV1FieldFactory,
    UserSelectorV1FieldFactory,
    MultipleTagSelectorV1FieldFactory,
    SingleTagSelectorV1FieldFactory,
    ArtworkLinkSelectorV1FieldFactory,
    DynamicUrlLinkButtonV1FieldFactory,
    // CodeGeneratorV1FieldFactory
];